import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { Modal } from '@ui/components/Modal'

import { ClientPhoneNumberDto } from '@model/AccountDetailedDto'

interface Props {
  phoneNumber: ClientPhoneNumberDto
  onConfirm: () => void
}

export const PhoneNumberDeleteModal: BaseModalType<Props> = ({ close, onConfirm, phoneNumber }) => {
  const { t } = useTranslation()
  return (
    <Modal>
      <Modal.Header>
        {t('Delete')} {phoneNumber.countryCode + phoneNumber.number}
      </Modal.Header>
      <Modal.Body>
        <Modal.Body.Text>
          {t('PhoneNumbers.Do you really want to delete this number?')}
        </Modal.Body.Text>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={close}>{t('Cancel')}</Modal.Footer.Secondary>
        <Modal.Footer.Primary
          onClick={() => {
            onConfirm()
            close()
          }}
        >
          {t('Delete')}
        </Modal.Footer.Primary>
      </Modal.Footer>
    </Modal>
  )
}
